<app-page-header
  [title]="'Gestión Financiera'"
  [subtitle]="'Vinculaciones'"
></app-page-header>

<div class="card">
  <p-tabView
    styleClass="tabview-custom"
    [(activeIndex)]="modalitieTabIndex"
    (onChange)="onModalitieTabChange($event)"
  >
    <p-tabPanel header="MANUAL_VALIDATION">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-check-circle" style="font-size: 1.5rem"></i>
          <span class="font-bold white-space-nowrap m-0">
            Verificación de Pagos Manuales
          </span>
        </div>
      </ng-template>
      <div *ngIf="showPaymenManualValidation" class="p-mt-2">
        <p-toast />

        <p-table
          #dt
          [value]="applicationsByPayment"
          [rows]="10"
          [paginator]="true"
          [globalFilterFields]="['clubName']"
          [rowHover]="true"
          dataKey="id"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [showCurrentPageReport]="true"
          class="p-datatable-sm table'"
        >
          <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
              <h5 class="m-0">Solicitudes pendientes de verificación</h5>
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filterGlobal($any($event.target).value, 'contains')
                  "
                  placeholder="Search..."
                />
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="type" class="table__header">
                Club <p-sortIcon field="name" />
              </th>
              <th pSortableColumn="name" class="table__header">
                Cantidad Nuevos
              </th>
              <th pSortableColumn="name" class="table__header">Valor Nuevos</th>
              <th pSortableColumn="startDate" class="table__header">
                Cantidad Renovaciones <p-sortIcon field="price" />
              </th>
              <th pSortableColumn="location" class="table__header">
                Valor Renovaciones <p-sortIcon field="rating" />
              </th>
              <th pSortableColumn="category" class="table__header">
                Total a pagar <p-sortIcon field="inventoryStatus" />
              </th>
              <th class="table__header">Acciones</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-applicationByPayment>
            <tr class="table__row">
              <td>
                {{ applicationByPayment.clubName }}
              </td>
              <td>
                {{
                  getRegistrarions(applicationByPayment.paymentId, "nuevo")
                    .length
                }}
              </td>
              <td>
                {{ calculateAmount(applicationByPayment.paymentId, "nuevo") }}
              </td>
              <td>
                {{
                  getRegistrarions(applicationByPayment.paymentId, "renovacion")
                    .length
                }}
              </td>
              <td>
                {{
                  calculateAmount(applicationByPayment.paymentId, "renovacion")
                }}
              </td>
              <td>
                {{ calculateTotalAmount(applicationByPayment.paymentId) }}
              </td>
              <td>
                <p-button
                  icon="pi pi-users"
                  [rounded]="true"
                  [text]="true"
                  severity="info"
                  [raised]="true"
                  class="table__button"
                  pTooltip="Vinculaciones Asociadas"
                  tooltipPosition="bottom"
                  (onClick)="openApplications(applicationByPayment)"
                />

                <p-button
                  icon="pi pi-file"
                  [rounded]="true"
                  [text]="true"
                  [raised]="true"
                  severity="warning "
                  class="table__button"
                  pTooltip="Ver Soporte"
                  tooltipPosition="bottom"
                  (onClick)="showSupport(applicationByPayment)"
                />

                <p-button
                  icon="pi pi-check-circle"
                  [rounded]="true"
                  [text]="true"
                  [raised]="true"
                  severity="success"
                  class="table__button"
                  pTooltip="Emitir Concepto"
                  tooltipPosition="bottom"
                  (onClick)="validateApplication(applicationByPayment)"
                />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
              {{ applicationsByPayment ? applicationsByPayment.length : 0 }}
              solicitudes en total.
            </div>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>
    <p-tabPanel header="VERIFICATION_HISTORY">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-book" style="font-size: 1.5rem"></i>
          <span class="font-bold white-space-nowrap m-0"
            >Historial de Verificaciones</span
          >
        </div>
      </ng-template>
      <div *ngIf="showVerificationHistory" class="p-mt-2">
        <p-toast />

        <p-table
          #dtHistory
          [value]="filteredVerifiedPayments"
          [rows]="10"
          [paginator]="true"
          [globalFilterFields]="[
            'clubName',
            'paymentId',
            'statusLabel',
            'verifiedBy'
          ]"
          [rowHover]="true"
          dataKey="paymentId"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [showCurrentPageReport]="true"
          styleClass="p-datatable-sm"
        >
          <ng-template pTemplate="caption">
            <div class="history-caption">
              <h5 class="m-0">Pagos manuales ya verificados</h5>
              <div class="history-caption__tools">
                <p-selectButton
                  [options]="historyStatusOptions"
                  [(ngModel)]="historyStatusFilter"
                  (onChange)="applyHistoryFilter()"
                  optionLabel="label"
                  optionValue="value"
                />
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    (input)="
                      dtHistory.filterGlobal(
                        $any($event.target).value,
                        'contains'
                      )
                    "
                    placeholder="Search..."
                  />
                </span>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="clubName" class="table__header">
                Club <p-sortIcon field="clubName" />
              </th>
              <th pSortableColumn="newCount" class="table__header">
                Cantidad Nuevos <p-sortIcon field="newCount" />
              </th>
              <th pSortableColumn="newAmount" class="table__header">
                Valor Nuevos <p-sortIcon field="newAmount" />
              </th>
              <th pSortableColumn="renewalCount" class="table__header">
                Cantidad Renovaciones <p-sortIcon field="renewalCount" />
              </th>
              <th pSortableColumn="renewalAmount" class="table__header">
                Valor Renovaciones <p-sortIcon field="renewalAmount" />
              </th>
              <th pSortableColumn="totalAmount" class="table__header">
                Total Pagado <p-sortIcon field="totalAmount" />
              </th>
              <th pSortableColumn="statusLabel" class="table__header">
                Concepto <p-sortIcon field="statusLabel" />
              </th>
              <th pSortableColumn="verificationDate" class="table__header">
                Fecha Verificación <p-sortIcon field="verificationDate" />
              </th>
              <th pSortableColumn="verifiedBy" class="table__header">
                Verificado Por <p-sortIcon field="verifiedBy" />
              </th>
              <th class="table__header">Observaciones</th>
              <th class="table__header">Acciones</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-verifiedPayment>
            <tr class="table__row">
              <td>
                {{ verifiedPayment.clubName }}
                <small class="history-reference"
                  >Ref. pago: {{ verifiedPayment.paymentId }}</small
                >
              </td>
              <td>{{ verifiedPayment.newCount }}</td>
              <td>{{ verifiedPayment.newAmount | number }}</td>
              <td>{{ verifiedPayment.renewalCount }}</td>
              <td>{{ verifiedPayment.renewalAmount | number }}</td>
              <td>{{ verifiedPayment.totalAmount | number }}</td>
              <td>
                <p-tag
                  [value]="verifiedPayment.statusLabel"
                  [severity]="verifiedPayment.statusSeverity"
                ></p-tag>
              </td>
              <td>{{ verifiedPayment.verificationDate }}</td>
              <td>{{ verifiedPayment.verifiedBy }}</td>
              <td class="history-comments">
                {{ verifiedPayment.comments || '—' }}
              </td>
              <td>
                <p-button
                  icon="pi pi-users"
                  [rounded]="true"
                  [text]="true"
                  severity="info"
                  [raised]="true"
                  class="table__button"
                  pTooltip="Vinculaciones Asociadas"
                  tooltipPosition="bottom"
                  (onClick)="openApplications(verifiedPayment)"
                />
                <p-button
                  icon="pi pi-file"
                  [rounded]="true"
                  [text]="true"
                  [raised]="true"
                  severity="warning"
                  class="table__button"
                  pTooltip="Ver Soporte"
                  tooltipPosition="bottom"
                  (onClick)="showSupport(verifiedPayment)"
                />
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="11">
                Aún no hay pagos manuales verificados para mostrar.
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
              {{ filteredVerifiedPayments.length }} verificaciones en total.
            </div>
          </ng-template>
        </p-table>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<p-dialog
  *ngIf="showDocumentPreview"
  [header]="documentPreviewSelected.documentName"
  [(visible)]="showDocumentPreview"
  [modal]="true"
  [style]="{ width: '90vw', height: '100vh' }"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
>
  <iframe
    allowfullscreen
    [src]="documentPreviewSelected.base64"
    [title]="documentPreviewSelected.documentName"
    class="responsive-iframe"
  ></iframe>
</p-dialog>

<p-dialog
  *ngIf="showVinculationDetails"
  [header]="'Solicitudes de vinculación asociadas al pago'"
  [(visible)]="showVinculationDetails"
  [modal]="true"
  [style]="{ width: '90vw', height: '100vh' }"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
>
  <div class="lpa-modal-table-container">
    <p-table
      #dt
      [value]="applicationsByPaymentSelected"
      [rows]="10"
      [paginator]="true"
      [globalFilterFields]="[
        'type',
        'applicant.name',
        'applicant.lastName',
        'applicant.idType',
        'applicant.idNumber',
        'applicant.contactInformation.email',
        'process.processStage',
        'created_at'
      ]"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      [rowHover]="true"
      dataKey="ApplicationId"
      styleClass="lpa-modal-table"
      [rowsPerPageOptions]="[5,10,20]"
      currentPageReportTemplate="Registros del {first} al {last} de {totalRecords} registros"
      [showCurrentPageReport]="true"
    >
    <ng-template pTemplate="caption">
      <div class="modal-table-caption">
        <div class="modal-table-caption__actions">
          <button
            pButton
            label="Limpiar Filtros"
            class="p-button-outlined"
            icon="pi pi-filter-slash"
            (click)="clear(dt)"
          ></button>
          <p-button
            icon="pi pi-file-excel"
            label="Exportar vinculaciones"
            [disabled]="applicationsByPaymentSelected.length === 0"
            (onClick)="exportApplicationsOfPayment()"
            pTooltip="Descarga en Excel las solicitudes asociadas a este pago"
            tooltipPosition="bottom"
          />
        </div>

        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Búsqueda por palabras"
          />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th id="tipoSolicitud" class="table__header-title">
          Tipo Solicitud

          <p-columnFilter
            type="text"
            field="type"
            display="menu"
            [showMatchModes]="false"
            matchMode="contains"
            [hideOnClear]="true"
          ></p-columnFilter>
        </th>
        <th id="tipoSolicitud" class="table__header-title">
          Club

          <p-columnFilter
            type="text"
            field="club"
            display="menu"
            [showMatchModes]="false"
            matchMode="contains"
            [hideOnClear]="true"
          ></p-columnFilter>
        </th>
        <th id="tipoSolicitud" class="table__header-title">
          Modalidad

          <p-columnFilter
            type="text"
            field="modalidad"
            display="menu"
            [showMatchModes]="false"
            matchMode="contains"
            [hideOnClear]="true"
          ></p-columnFilter>
        </th>
        <th id="nombre" class="table__header-title">
          Nombre
          <p-columnFilter
            type="text"
            field="applicant.name"
            display="menu"
            [showMatchModes]="false"
            matchMode="contains"
            [hideOnClear]="true"
          ></p-columnFilter>
        </th>
        <th
          id="apellido"
          pSortableColumn="apellido"
          class="table__header-title"
        >
          Apellido

          <p-columnFilter
            type="text"
            field="applicant.lastName"
            display="menu"
            [showMatchModes]="false"
            matchMode="contains"
            [hideOnClear]="true"
          ></p-columnFilter>
        </th>
        <th
          id="tipoIdentificacion"
          pSortableColumn="tipoIdentificacion"
          class="table__header-title"
        >
          Tipo Identificación
        </th>
        <th
          id="numeroIdentificacion"
          pSortableColumn="numeroIdentificacion"
          class="table__header-title"
        >
          Numero Identificación

          <p-columnFilter
            type="text"
            field="applicant.idNumber"
            display="menu"
            [showMatchModes]="false"
            matchMode="contains"
            [hideOnClear]="true"
          ></p-columnFilter>
        </th>
        <th
          id="status"
          pSortableColumn="process.processStage"
          class="table__header-title"
        >
          Estado<p-sortIcon
            field="process.processStage"
            class="table__header-sortIcon"
          ></p-sortIcon>
        </th>
        <th
          id="fechaSolicitud"
          pSortableColumn="created_at"
          class="table__header-title"
        >
          Fecha Solicitud
          <p-sortIcon
            field="created_at"
            class="table__header-sortIcon"
          ></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-application let-columns="columns">
      <tr>
        <td>
          <span class="p-column-title font-bold">Tipo Solicitud</span>
          {{
            application?.type === "nuevo"
              ? "Nueva Vinculación"
              : "Renovación de Vinculación"
          }}
        </td>
        <td>
          <span class="p-column-title font-bold">Club</span
          >{{ application?.club?.name }}
        </td>
        <td>
          <span class="p-column-title font-bold">Modalidad</span
          >{{ application?.modalidad }}
        </td>
        <td>
          <span class="p-column-title font-bold">Nombres</span
          >{{ application?.applicant?.name }}
        </td>
        <td>
          <span class="p-column-title font-bold">Apellidos</span
          >{{ application?.applicant?.lastName }}
        </td>
        <td>
          <span class="p-column-title font-bold">Tipo Id</span
          >{{ application?.applicant?.idType }}
        </td>
        <td>
          <span class="p-column-title font-bold">Id</span
          >{{ application?.applicant?.idNumber }}
        </td>
        <td>
          <span class="p-column-title font-bold">Estado</span>
          {{ getSeverity(application.process.processStage) }}
        </td>
        <td>
          <span class="p-column-title font-bold">Fecha Solicitud</span
          >{{ getHumanTime(application?.created_at) }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between">
        Total de solicitudes
        {{
          applicationsByPaymentSelected
            ? applicationsByPaymentSelected.length
            : 0
        }}.
      </div>
    </ng-template>
    </p-table>
  </div>
</p-dialog>

<p-dialog
  *ngIf="showRevisionConceptModal"
  [header]="'Emitir concepto de verificación del pago manual'"
  [(visible)]="showRevisionConceptModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
>
  <div class="confirm-payment__modal">
    <p-selectButton
      [options]="paymentStatusOptions"
      [(ngModel)]="paymentStatusSelected"
      optionLabel="label"
      optionValue="value"
    />
  </div>
  <div
    *ngIf="paymentStatusSelected === 'rejected'"
    class="confirm-payment__rejected"
  >
    <div>
      <span>Indique el motivo del rechazo:</span>
    </div>
    <div>
      <textarea
        rows="5"
        cols="80"
        pInputTextarea
        [(ngModel)]="paymentRejectReason"
      >
      </textarea>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      label="Cancelar"
      [text]="true"
      severity="secondary"
      (onClick)="onCancelPaymentResponse()"
    />
    <p-button
      label="Confirmar"
      [outlined]="true"
      severity="primary"
      [disabled]="paymentStatusSelected === 'rejected' && paymentRejectReason.trim().length <= 0"
      (onClick)="onConfirmPaymentResponse()"
    />
  </ng-template>
</p-dialog>
